import { useShopPageContainer, useShopPageFetch } from "@tenant/hotels";
import type { ShopPageRouteProps } from "../types";

export const useShopPage = (props: ShopPageRouteProps) => {
  useShopPageFetch(props);
  return useShopPageContainer({ goToNextStep: props.goToNextStep });
};
